import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import '../../App.css';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import useCountUp from '../../hooks/useCountUp';

const stats = [
  { target: 180, prefix: '$', suffix: 'M+', label: 'Trading Volume Processed', comma: false },
  { target: 50000, prefix: '', suffix: '+', label: 'Customers Served', comma: true },
  { target: 10, prefix: '', suffix: '+', label: 'Digital Asset Rails', comma: false },
];

const StatItem = ({ stat, index, isVisible, colorClass }) => {
  const count = useCountUp(stat.target, 1800, isVisible);
  const display = stat.comma ? count.toLocaleString() : count;

  return (
    <Box
      id={`stats-item-${stat.label.toLowerCase().replace(/\s+/g, '-')}`}
      className={`anim-fade-up anim-d${index}${isVisible ? ' in-view' : ''}`}
      sx={{ textAlign: 'center', position: 'relative' }}
    >
      <Typography
        className={colorClass}
        sx={{
          fontSize: { xs: '2.75rem', sm: '3.25rem', md: '3.75rem' },
          mb: 1.5,
          lineHeight: 1,
          letterSpacing: '-0.02em',
        }}
      >
        {stat.prefix}{display}{stat.suffix}
      </Typography>
      <Typography className="stats-label" sx={{ lineHeight: 1.4 }}>
        {stat.label}
      </Typography>

      {index < stats.length - 1 && (
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            right: { sm: '-25px', md: '-90px' },
            transform: 'translateY(-50%)',
            width: '3px',
            height: '60px',
            backgroundColor: '#EAEEFF',
            display: { xs: 'none', sm: 'block' },
          }}
        />
      )}
    </Box>
  );
};

const StatsSection = () => {
  const [headerRef, headerVisible] = useScrollAnimation(0.2);
  const [gridRef, gridVisible] = useScrollAnimation(0.1);

  return (
    <Box
      component="section"
      sx={{
        pt: { xs: 10, md: 8 },
        pb: { xs: 10, md: 3 },
        backgroundColor: 'Global Execution. Proven at Scale.',
        color: '#fff',
      }}
    >
      <Container maxWidth="lg">
        <Box
          ref={headerRef}
          className={`anim-fade-up${headerVisible ? ' in-view' : ''}`}
          sx={{ textAlign: 'center', mb: { xs: 8, md: 10 } }}
        >
          <Typography
            variant="h2"
            className="stats-title"
            sx={{ mb: 2.5, letterSpacing: '-0.02em' }}
          >
            Global Execution. Proven at Scale.
          </Typography>
          <Typography
            className="stats-desc"
            sx={{ maxWidth: '90%', mx: 'auto', lineHeight: 1.7 }}
          >
            Built on trust, backed by experience. A reliable partner for accessing digital assets with confidence.
          </Typography>
        </Box>

        <Box
          ref={gridRef}
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(3, 1fr)',
              md: 'repeat(3, 1fr)',
            },
            justifyItems: 'center',
            gap: { xs: 6, md: 16 },
          }}
        >
          {stats.map((item, index) => (
            <StatItem
              key={item.label}
              stat={item}
              index={index}
              isVisible={gridVisible}
              colorClass={index % 2 === 0 ? 'stats-value-primary' : 'stats-value-white'}
            />
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default StatsSection;
